import { createFileRoute } from '@tanstack/react-router'
import { requireAccess } from '../../../app/guards'
import { PURCHASING_ACCESS } from '../../../features/purchasing/access'
import { NewSupplierPaymentPage } from '../../../features/purchasing/payment-pages'
import { newPaymentSearchSchema } from '../../../features/purchasing/search'
import { treasuryOptionsQueryOptions } from '../../../features/sales/queries'

export const Route = createFileRoute('/_app/supplier-payments/new')({
  staticData: { crumb: 'supplierPaymentNew' },
  validateSearch: newPaymentSearchSchema,
  beforeLoad: ({ context }) => requireAccess(context.session, PURCHASING_ACCESS.supplierPayment),
  loader: ({ context }) => {
    // Warm the cash/bank picker; the form does not wait for it.
    void context.queryClient.prefetchQuery(treasuryOptionsQueryOptions)
  },
  component: NewSupplierPaymentPage,
})
